import { Environment, Metadata, Geometry } from '@workspaces/types'
import { GeometryService } from '@workspaces/services'

export default {
  async getGeometriesCustomFileGeometries(
    meta: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
    fileIds: string[],
  ): Promise<Geometry.Geometry[]> {
    return await GeometryService.getGeometriesCustomFileGeometries(
      meta,
      environment,
      fileIds,
    )
  },
}
